import { ApiExportData } from "src/api";

export const incomingMessageEventNames = [
	"enableCart",
	"enableTemplates",
	"enableEstimate",
	"disableVAT",
	"openDesign",
] as const;

export type IncomingMessageEventName =
	(typeof incomingMessageEventNames)[number];

const incomingMessagePayloads = {
	enableCart: undefined,
	enableTemplates: undefined,
	enableEstimate: undefined,
	disableVAT: undefined,
	openDesign: {} as { designId: string },
} satisfies Record<IncomingMessageEventName, unknown>;

export type IncomingMessagePayloads = {
	[K in keyof typeof incomingMessagePayloads]: (typeof incomingMessagePayloads)[K];
};

export type IncomingMessageData = {
	event: IncomingMessageEventName;
	data: unknown;
};

export type IncomingMessageEvent = MessageEvent<IncomingMessageData>;

/* ------ OUTGOING ------ */
export enum OutgoingMessageEventType {
	BYO_LOADED = "byoLoaded",
	CART_UPDATE = "cartUpdate",
	DESIGN_UPDATE = "designUpdate",
	SHOW_WIZARD = "showWizard",
	EXIT = "exit",
	OPEN_IN_AR = "OpenInAr",
	VIEWER_ERROR = "viewerError",
}

export type OutgoingMessageData = {
	data: ApiExportData & {
		url: string;
		snapshot?: string;
	};
};

export type ViewerErrorMessageData = {
	data: {
		message: string;
	};
};
